// =============================================================================
// src/features/analytics/analytics-insights-edition-data.ts - Capa da edicao.
// Proveniencia: assets/atalaia-relatorios/Insights - inteligencia/cards md/
// Diario_Anexo-CardsTaticos_2026-07-25.md (linhas 1-25 + rodape), portado
// verbatim em 2026-07-27. Conteudo mantem acentos e enfases (<strong>) do
// documento original — fidelidade e requisito, nao estilo.
// =============================================================================

import type { AnalyticsInsightEdition } from './analytics-insights-types';

export const ANALYTICS_INSIGHTS_EDITION: AnalyticsInsightEdition = {
  monitoredHtml:
    'Monitorado: <strong>Omar Aziz (PSD)</strong> · Estrutura da disputa, terreno de pauta e terreno de imprensa',
  cutLabel: '25/07/2026, 00h00 (Manaus)',
  analyticalWindowLabel: '17 a 24/07/2026 (8 dias)',
  extractionLabel: '25/07/2026, 11h10 (Manaus)',
  baseVolumesLabel: '4.544 comentaristas distintos · 1.004 publicações · 1.472 matérias',
  cardCountLabel: '10',
  // coverNotesHtml[0] = nota editorial da edicao; [1] = nota de metodo/confianca
  // (eram os campos editorialNoteHtml/methodNoteHtml antes da lista de 2026-07-28).
  coverNotesHtml: [
    '<strong>Esta edição substitui a edição das 02h desta mesma data e cancela os números dela.</strong> A janela ' +
      'analítica é idêntica; o que mudou foi o instante da extração. Nas nove horas entre as duas leituras, ' +
      'o acompanhamento terminou de alcançar o último dia da janela e a base da MESMA janela cresceu 22,5% ' +
      'em comentaristas e 41,0% em publicações. Seis métricas que sustentam três cards se moveram acima do ' +
      'piso de ruído — por isso os cards foram refeitos, e não apenas reconfirmados. <strong>A disputa não andou ' +
      'nessas nove horas; a medição é que ficou completa.</strong> Nenhuma variação deste documento deve ser lida ' +
      'como crescimento político; o CARD 10 trata disso e é o único achado novo da edição.',
    'Cada card cruza duas dimensões diferentes da base — identidade de audiência, série de pauta, ' +
      'ocupação de espaço de terceiros — para produzir leitura que o volume diário não entrega. Toda ' +
      'hipótese foi submetida a teste de refutação antes de virar card, e o teste aplicado está declarado ' +
      'no rodapé. Confiança <strong>ALTA</strong> = medido e validado contra explicação alternativa; ' +
      '<strong>MÉDIA</strong> = medido, amostra limitada. Nenhuma informação externa à base foi usada: não há ' +
      'pesquisa de intenção de voto, declaração de palanque ou manchete interpretada neste documento — ' +
      'apenas o que está registrado no acompanhamento.',
  ],
  documentFooter:
    'ATALAIA — Cards de Inteligência Tática, complemento ao Paper Diário · Edição 25/07/2026 ' +
    '(extração das 11h10, substitui a das 02h) · Documento interno e confidencial.',
};
